export default "__VITE_ASSET__ce6ecedc__"